/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated';
import { createCombinations } from '../../factoriesAny.js';
export var combinationsDependencies = {
  typedDependencies: typedDependencies,
  createCombinations: createCombinations
};